<template>
    <div>
        <h1 class="text-center mt-4 d-none d-lg-block">Bienvenido al sistema de facturaci&oacute;n en l&iacute;nea <br> de CASA AHUED SA
            DE CV
        </h1>
        <h4 class="text-center mt-4 d-lg-none">Bienvenido al sistema de facturaci&oacute;n en l&iacute;nea <br> de CASA AHUED SA
            DE CV
        </h4>
        <div class="card mt-lg-5 mt-3">
            <div class="card-header text-center bg-custom text-white h5">
                <b-icon icon="info-circle"></b-icon>
                Ponemos a su disposici&oacute;n nuestro portal en l&iacute;nea para agilizar el proceso de facturaci&oacute;n
            </div>
            <div class="card-body px-md-5 py-4">
                <p class="card-text">Tome en cuenta los siguientes puntos:</p>
                <ul>
                    <li>Solo se permitir&aacute;n facturar notas de venta emitidos dentro del mismo mes.</li>
                    <li>En caso de requerir cancelaci&oacute;n de su factura, favor de comunicarse con el depto. de
                        contabilidad.
                    </li>
                </ul>
                <p class="card-text">
                    Gracias!
                </p>
                <p class="card-text">
                    Depto. de contabilidad <br>
                    2288171266 ext. 1003 <br>
                    tiendaenlinea@casaahued.com
                </p>
       
                <router-link tag="a" :to="{ name: 'Invoice' }" class="btn btn-custom">
                    <b>Facturar</b>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StartAhued',
    }
    
</script>

